import { useMutation, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import {
  updateLineSettings,
  verifyLineSettings,
} from '@/features/internal/patient-messaging/apis/lineSettingsApi'
import { LineSettingsUpdatePayload } from '@/features/internal/patient-messaging/types/lineSettings'

export const useUpdateLineSettingsMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (payload: LineSettingsUpdatePayload) =>
      updateLineSettings(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.patientMessaging.lineSettings(),
      })
    },
  })
}

export const useVerifyLineSettingsMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => verifyLineSettings(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.patientMessaging.lineSettings(),
      })
    },
  })
}
